/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto } from './WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto';
import {
    WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDtoFromJSONTyped,
    WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDtoToJSON,
} from './WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto';

/**
 * CreateReply dto
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto {
    /**
     * Gets or sets the identifier.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto
     */
    id?: number;
    /**
     * The times where the reply has a place.
     * @type {Array<number>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto
     */
    acceptedTimeIds?: Array<number> | null;
    /**
     * The times where the reply is on the waitlist.
     * @type {Array<number>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto
     */
    waitlistedTimeIds?: Array<number> | null;
    /**
     * The result for each person when a household was signed up; empty otherwise.
     * @type {Array<WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto
     */
    people?: Array<WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto {
    return WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'acceptedTimeIds': !exists(json, 'acceptedTimeIds') ? undefined : json['acceptedTimeIds'],
        'waitlistedTimeIds': !exists(json, 'waitlistedTimeIds') ? undefined : json['waitlistedTimeIds'],
        'people': !exists(json, 'people') ? undefined : (json['people'] === null ? null : (json['people'] as Array<any>).map(WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDtoFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'acceptedTimeIds': value.acceptedTimeIds,
        'waitlistedTimeIds': value.waitlistedTimeIds,
        'people': value.people === undefined ? undefined : (value.people === null ? null : (value.people as Array<any>).map(WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDtoToJSON)),
    };
}

